import { mainAxios as axios } from './axios'


export const getOvhList = async () => {
  return axios.get(`/ovh`)
}
export const validateOvhApi = async ({ external_api_key_id }) => {
  return axios.get(`/ovh/account/${external_api_key_id}/validate-ordering-prerequisites`)
}
export const checkDomainAvailability = async ({ domain, external_api_key_id }) => {
  return axios.get(`/ovh/domain/availability/${domain}/${external_api_key_id}`)
}
export const importOvh = async ({ external_api_key_id }) => {
  return axios.post(`/ovh/sync-assets`, { external_api_key_id })
}
export const checkoutOvh = async ({ domain, external_api_key_id, emails }) => {
  return axios.post(`/ovh/checkout`, { domain, external_api_key_id, emails })
}
export const deleteOvhDomain = async ({ id }) => {
  return axios.delete(`/ovh/domain/${id}`)
}
export const deleteOvhEmail = async ({ id }) => {
  return axios.delete(`/ovh/email/${id}`)
}